// Session start times — the text-box representation used by the Bases form.
//
// A PURE MODULE, no React: the verify gate imports it directly. The generic admin form only
// carries string | number | boolean values (adminUi FormValues), so the grid is TYPED as a
// comma-separated list and converted here, at one seam, rather than in the form component.
//
// ⚠ THE SERVER IS THE AUTHORITY. It re-validates, sorts, deduplicates and caps
// (backend lib/sessionTimes.ts + bases.schemas). This module exists to make the box pleasant
// to type into, not to decide what is acceptable — an invalid entry is passed through so the
// server's message is what the operator sees, rather than being silently dropped here.

export const HHMM_RE = /^([01]\d|2[0-3]):[0-5]\d$/;

// Mirrors MAX_SESSION_TIMES in the backend module. Used only for the field hint — the cap
// itself is enforced server-side.
export const MAX_SESSION_TIMES = 12;

// "08:00, 10:00 13:00" → ["08:00","10:00","13:00"]. Splits on commas and whitespace so a
// pasted list works whichever way it was separated. An empty box → [] (which the caller turns
// into an explicit null: clearing the grid, not leaving it alone).
export function parseSessionTimes(input: string): string[] {
  return input.split(/[\s,]+/).map((t) => t.trim()).filter(Boolean);
}

// string[] (or the raw Json? value straight off the API) → "08:00, 10:00, 13:00".
export function formatSessionTimes(value: unknown): string {
  if (!Array.isArray(value)) return '';
  return value.filter((v): v is string => typeof v === 'string').join(', ');
}

// The entries that will fail the server's HH:MM check, so the form can say so before the
// round trip. Advisory: the Save is not blocked on it.
export function invalidSessionTimes(times: string[]): string[] {
  return times.filter((t) => !HHMM_RE.test(t));
}
